<template>
  <div>
    <div id="js-lineup__product--trigger"></div>
    <div id="js-lineup__product--pin">
      <div class="js-lineup__product" :data-count-num=listSort.length>
        <ul :class="'lineup__product lineup__product--col' + colNum">
          <ListItem v-for="item in listSort" :item="item" :key="item.id"></ListItem>
        </ul>
      </div>
      <ModalItem v-for="item in list" :item="item" :key="item.id"></ModalItem>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import ListItem from './ListItem.vue'
import ModalItem from './ModalItem.vue'
import Scroll from '../_Lineup.js'

export default {
  name: 'List',
  // props: ['val'],
  components: {
    ListItem,
    ModalItem,
  },
  mounted : function(){
    new Scroll();
  },
  data () {
    return {
      filter: this.$store.state.filter,
      // msg: 'Hello Vue Component   ttm',
      list: [

        {
          id: '3041',
          productName: 'レディース\n牛革コインローファー',
          num: 'NO.3041',
          wise: '1E',
          heels: '約25mm',
          size: ' 22.5-25.5',
          color: ['black','brown'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/010304100',
          cat: {
            all: ['1','4','7','8','11','14'],
            // mat: ['1'],
            // wid: ['1'],
            // col: ['1','2'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'hon',//hon/su/gou
          img: {
            model: './share/images/lineup_txt3041.svg',
            main: './share/images/lineup_img3041.png',
            sub: './share/images/lineup_img3041b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','229.0','206.0'],
            ['23','234.0','209.5'],
            ['23.5','239.0','213.0'],
            ['24','244.0','216.5'],
            ['24.5','249.0','220.0'],
            ['25','254.0','223.5'],
            ['25.5','259.0','227.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '304',
          productName: 'レディース\n牛革コインローファー',
          num: 'NO.304',
          wise: '2E',
          heels: '約25mm',
          size: ' 21.5-26.5',
          color: ['black','brown','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=coinloafer304',
          cat: {
            all: ['1','5','7','8','9','11','14'],
            // mat: ['1'],
            // wid: ['2'],
            // col: ['1','2','3'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt304.svg',
            main: './share/images/lineup_img304.png',
            sub: './share/images/lineup_img304.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','219.0','202.0'],
            ['22','224.0','205.5'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','259.0','230.0'],
            ['26','264.0','233.5'],
            ['26.5','269.0','237.0'],
          ]
        },
        {
          id: '3048',
          productName: 'レディース\n牛革コインローファー',
          num: 'NO.3048',
          wise: '3E',
          heels: '約25mm',
          size: ' 22.0-26.5',
          color: ['black','brown','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=coin3048',
          cat: {
            all: ['1','6','7','8','9','11','14'],
            // mat: ['1'],
            // wid: ['3'],
            // col: ['1','2','3'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt3048.svg',
            main: './share/images/lineup_img3048.png',
            sub: './share/images/lineup_img3048.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','228.0','208.5'],
            ['22.5','233.0','212.0'],
            ['23','238.0','215.5'],
            ['23.5','243.0','219.0'],
            ['24','248.0','222.5'],
            ['24.5','253.0','226.0'],
            ['25','258.0','229.5'],
            ['25.5','263.0','233.0'],
            ['26','268.0','236.5'],
            ['26.5','273.0','240.0'],
          ]
        },
        {
          id: '545',
          productName: 'レディース\n牛革ヒールアップローファー',
          num: 'NO.545',
          wise: '3E',
          heels: '約35mm',
          size: ' 22.5-25.5',
          color: ['black'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/loafers-school/010054500',
          cat: {
            all: ['1','6','7','11','15'],
            // mat: ['1'],
            // wid: ['3'],
            // col: ['1'],
            // des: ['1'],
            // hee: ['2'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt545.svg',
            main: './share/images/lineup_img545.png',
            sub: './share/images/lineup_img545b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','232.0','207.0'],
            ['23','237.0','210.5'],
            ['23.5','242.0','214.0'],
            ['24','247.0','217.5'],
            ['24.5','252.0','221.0'],
            ['25','257.0','224.5'],
            ['25.5','262.0','228.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '3804R',
          productName: '【限定中敷き】<br class="display--pc">新コインローファー',
          num: 'NO.3804R',
          wise: 'なし',
          heels: '約28mm',
          size: ' 22.5-25.5',
          color: ['black','brown'],
          hosoku: '※インソールでサイズ調整可能',
          url: 'https://www.haruta-shoes.co.jp/items/013804R0',
          cat: {
            all: ['1','4','5','6','7','8','11','14'],
            // mat: ['1'],
            // wid: ['2'],
            // col: ['1','2'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt3804R.svg',
            main: './share/images/lineup_img3804R.png',
            sub: './share/images/lineup_img3804Rb.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','232.0','211.0'],
            ['23','237.0','214.5'],
            ['23.5','242.0','218.0'],
            ['24','247.0','221.5'],
            ['24.5','252.0','225.0'],
            ['25','257.0','228.5'],
            ['25.5','262.0','232.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '303',
          productName: 'レディース\n牛革タッセルローファー',
          num: 'NO.303',
          wise: '2E',
          heels: '約25mm',
          size: ' 22.0-26.0',
          color: ['black','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=Tassel303',
          cat: {
            all: ['1','5','7','9','12','14'],
            // mat: ['1'],
            // wid: ['2'],
            // col: ['1','3'],
            // des: ['2'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt303.svg',
            main: './share/images/lineup_img303.png',
            sub: './share/images/lineup_img303b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','224.0','205.5'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','259.0','230.0'],
            ['26','264.0','233.5'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '313',
          productName: 'レディース\n牛革キルト\nタッセルローファー',
          num: 'NO.313',
          wise: '2E',
          heels: '約25mm',
          size: ' 22.0-25.5',
          color: ['black','brown','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/010031300',
          cat: {
            all: ['1','5','7','8','9','13','14'],
            // mat: ['1'],
            // wid: ['2'],
            // col: ['1','2','3'],
            // des: ['3'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt313.svg',
            main: './share/images/lineup_img313.png',
            sub: './share/images/lineup_img313.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','224.0','205.5'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','259.0','230.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '3138',
          productName: 'レディース\n牛革キルト\nタッセルローファー',
          num: 'NO.3138',
          wise: '3E',
          heels: '約25mm',
          size: ' 22.0-26.5',
          color: ['black','brown','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=kilttassel3138',
          cat: {
            all: ['1','6','7','8','9','13','14'],
            // mat: ['1'],
            // wid: ['3'],
            // col: ['1','2','3'],
            // des: ['3'],
            // hee: ['1'],
          },
          mat: 'hon',
          img: {
            model: './share/images/lineup_txt3138.svg',
            main: './share/images/lineup_img3138.png',
            sub: './share/images/lineup_img3138.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','228.0','208.5'],
            ['22.5','233.0','212.0'],
            ['23','238.0','215.5'],
            ['23.5','243.0','219.0'],
            ['24','248.0','222.5'],
            ['24.5','253.0','226.0'],
            ['25','258.0','229.5'],
            ['25.5','263.0','233.0'],
            ['26','268.0','236.5'],
            ['26.5','273.0','240.0'],
          ]
        },
        {
          id: '4514',
          productName: 'レディース\n人工皮革コインローファー',
          num: 'NO.4514',
          wise: '2E',
          heels: '約25mm',
          size: ' 21.5-26.0',
          color: ['black','brown','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=coin4514',
          cat: {
            all: ['2','5','7','8','9','11','14'],
            // mat: ['2'],
            // wid: ['2'],
            // col: ['1','2','3'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4514.svg',
            main: './share/images/lineup_img4514.png',
            sub: './share/images/lineup_img4514.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','219.0','202.0'],
            ['22','224.0','205.5'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','259.0','230.0'],
            ['26','264.0','233.5'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '4505',
          productName: 'レディース\n人工皮革コインローファー',
          num: 'NO.4505',
          wise: '3E',
          heels: '約30mm',
          size: ' 22.0-26.0',
          color: ['black','jamaica'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=coin4505',
          cat: {
            all: ['2','6','7','10','11','14'],
            // mat: ['2'],
            // wid: ['3'],
            // col: ['1','4'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4505.svg',
            main: './share/images/lineup_img4505.png',
            sub: './share/images/lineup_img4505b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','223.0','207.5'],
            ['22.5','228.0','211.0'],
            ['23','233.0','214.5'],
            ['23.5','238.0','218.0'],
            ['24','243.0','221.5'],
            ['24.5','248.0','225.0'],
            ['25','253.0','228.5'],
            ['25.5','258.0','232.0'],
            ['26','263.0','235.5'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '4582',
          productName: 'レディース\n人工皮革チェック\nインソールローファー',
          num: 'NO.4582',
          wise: '2E',
          heels: '約25㎜',
          size: ' 22.5-25.5',
          color: ['black'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/010458200',
          cat: {
            all: ['2','5','7','11','14'],
            // mat: ['2'],
            // wid: ['2'],
            // col: ['1'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4582.svg',
            main: './share/images/lineup_img4582.png',
            sub: './share/images/lineup_img4582b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','240.0','197.0'],
            ['23','245.0','200.5'],
            ['23.5','250.0','204.0'],
            ['24','255.0','207.5'],
            ['24.5','260.0','211.0'],
            ['25','265.0','214.5'],
            ['25.5','270.0','218.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '4900',
          productName: 'レディース\n人工皮革\nおでこローファー',
          num: 'NO.4900',
          wise: '3E',
          heels: '約35mm',
          size: ' 22.5-25.5',
          color: ['black','jamaica'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/010490000',
          cat: {
            all: ['2','6','7','10','11','15'],
            // mat: ['2'],
            // wid: ['3'],
            // col: ['1','4'],
            // des: ['1'],
            // hee: ['2'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4900.svg',
            main: './share/images/lineup_img4900.png',
            sub: './share/images/lineup_img4900b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','234.0','217.0'],
            ['23','239.0','220.5'],
            ['23.5','244.0','224.0'],
            ['24','249.0','227.5'],
            ['24.5','254.0','231.0'],
            ['25','259.0','234.5'],
            ['25.5','264.0','238.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '4603',
          productName: 'レディース\n人工皮革\nヒールアップローファー',
          num: 'NO.4603',
          wise: '3E',
          heels: '約45㎜',
          size: ' 22.5-25.5',
          color: ['black','jamaica'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/010460300',
          cat: {
            all: ['2','6','7','10','11','15'],
            // mat: ['2'],
            // wid: ['3'],
            // col: ['1','4'],
            // des: ['1'],
            // hee: ['2'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4603.svg',
            main: './share/images/lineup_img4603.png',
            sub: './share/images/lineup_img4603b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','234.0','211.0'],
            ['23','239.0','214.5'],
            ['23.5','244.0','218.0'],
            ['24','249.0','221.5'],
            ['24.5','254.0','225.0'],
            ['25','259.0','228.5'],
            ['25.5','264.0','232.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '45050',
          productName: 'レディース\n人工皮革カップインソール\nコインローファー',
          num: 'NO.45050',
          wise: '3E',
          heels: '約30mm',
          size: ' 22.5-25.5',
          color: ['black','jamaica'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/014505000',
          cat: {
            all: ['2','6','7','10','11','14'],
            // mat: ['2'],
            // wid: ['3'],
            // col: ['1','4'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt45050.svg',
            main: './share/images/lineup_img45050.png',
            sub: './share/images/lineup_img45050.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','228.0','211.0'],
            ['23','233.0','214.5'],
            ['23.5','238.0','218.0'],
            ['24','243.0','221.5'],
            ['24.5','248.0','225.0'],
            ['25','253.0','228.5'],
            ['25.5','258.0','232.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '46030',
          productName: 'レディース\n人工皮革カップインソール\nヒールアップコインローファー',
          num: 'NO.46030',
          wise: '3E',
          heels: '約45mm',
          size: ' 22.5-25.5',
          color: ['black','jamaica'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/014603000',
          cat: {
            all: ['2','6','7','10','11','15'],
            // mat: ['2'],
            // wid: ['3'],
            // col: ['1','4'],
            // des: ['1'],
            // hee: ['2'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt46030.svg',
            main: './share/images/lineup_img46030.png',
            sub: './share/images/lineup_img46030b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','234.0','211.0'],
            ['23','239.0','214.5'],
            ['23.5','244.0','218.0'],
            ['24','249.0','221.5'],
            ['24.5','254.0','225.0'],
            ['25','259.0','228.5'],
            ['25.5','264.0','232.0'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: '4515',
          productName: 'レディース\n人工皮革キルト\nタッセルローファー',
          num: 'NO.4515',
          wise: '2E',
          heels: '約25mm',
          size: ' 22.0-26.0',
          color: ['black','rota'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/p/search?keyword=kilt4515',
          cat: {
            all: ['2','5','7','9','13','14'],
            // mat: ['2'],
            // wid: ['2'],
            // col: ['1','3'],
            // des: ['3'],
            // hee: ['1'],
          },
          mat: 'gou',
          img: {
            model: './share/images/lineup_txt4515.svg',
            main: './share/images/lineup_img4515.png',
            sub: './share/images/lineup_img4515b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','224.0','205.5'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','259.0','230.0'],
            ['26','264.0','233.5'],
            ['26.5','-','-'],
          ]
        },
        {
          id: 'SD304',
          productName: 'レディース\nソフト素材のスコッチガード\nコインローファー',
          num: 'NO.SD304',
          wise: '2E',
          heels: '約25mm',
          size: ' 22.5-25.0',
          color: ['black','darkbrown'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/01SD30400',
          cat: {
            all: ['3','5','7','8','11','14'],
            // mat: ['3'],
            // wid: ['2'],
            // col: ['1','2'],
            // des: ['1'],
            // hee: ['1'],
          },
          mat: 'su',
          img: {
            model: './share/images/lineup_txtsd304.svg',
            main: './share/images/lineup_imgsd304.png',
            sub: './share/images/lineup_imgsd304b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','-','-'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },
        {
          id: 'SD303',
          productName: 'レディース\nソフト素材のスコッチガード\nタッセルローファー',
          num: 'NO.SD303',
          wise: '2E',
          heels: '約25mm',
          size: ' 22.5-25.0',
          color: ['black','darkbrown'],
          hosoku: '',
          url: 'https://store.haruta-shoes.co.jp/c/loafers/01SD30300',
          cat: {
            all: ['3','5','7','8','12','14'],
            // mat: ['3'],
            // wid: ['2'],
            // col: ['1','2'],
            // des: ['2'],
            // hee: ['1'],
          },
          mat: 'su',
          img: {
            model: './share/images/lineup_txtsd303.svg',
            main: './share/images/lineup_imgsd303.png',
            sub: './share/images/lineup_imgsd303b.png',
          },
          table: [
            ['21','-','-'],
            ['21.5','-','-'],
            ['22','-','-'],
            ['22.5','229.0','209.0'],
            ['23','234.0','212.5'],
            ['23.5','239.0','216.0'],
            ['24','244.0','219.5'],
            ['24.5','249.0','223.0'],
            ['25','254.0','226.5'],
            ['25.5','-','-'],
            ['26','-','-'],
            ['26.5','-','-'],
          ]
        },

      ]
    }
  },
  updated: function(){
  },
  computed : {
    listSort : function(){
      // 選択なし
      if(
        !this.$store.state.filter.all.length
        // !this.$store.state.filter.mat.length &&
        // !this.$store.state.filter.wid.length &&
        // !this.$store.state.filter.col.length &&
        // !this.$store.state.filter.des.length &&
        // !this.$store.state.filter.hee.length
      ) {
        return this.list;
      } else {
        return this.getList();
      }

      // window.lineUpcontroller.destroy();
      window.lineUpcontroller.removeScene(window.lineUpScene);
      // window.lineUpScene.destroy();
    },
    mat1 : function(){
      // console.log(this.$store.state.filter.mat.find(item => item == '1'));
      return this.$store.state.filter.mat.find(item => item == '1')? 1 : 0;
    },
    wid1 : function(){
      // console.log(this.$store.state.filter.wid.find(item => item == '1'));
      return this.$store.state.filter.wid.find(item => item == '1')? 1 : 0;
    },
    colNum : function(){
      var len = this.listSort.length;
      var colNum;
      if(len <= 4) colNum = 2;
      else if(len <= 9) colNum = 3;

      // console.log(this.listSort.length,'-----this.listSort.length',colNum);
      // console.log(this.$store.state.filter.wid.find(item => item == '1'));
      // return this.$store.state.filter.wid.find(item => item == '1')? 1 : 0;
      return colNum;
    },
  },

  // watch: {
  //   'filter': {
  //     handler: function(newValue, oldValue) {
  //       console.log("$('.lineup__product').height()",$('.lineup__product').height());
  //       // alert('変更を検出しました');
  //     },
  //   deep: true
  //   }
  // },

  methods: {

    getList : function(){

      var flg = false;
      var listSort = [];
      var all = this.$store.state.filter.all;
      // var matAry = this.$store.state.filter.mat;
      // var widAry = this.$store.state.filter.wid;
      // var colAry = this.$store.state.filter.col;
      // var desAry = this.$store.state.filter.des;
      // var heeAry = this.$store.state.filter.hee;

      this.list.forEach(function(li){
        // console.log(this.getDuplicateValues([...matAry, ...li.cat.mat]));
        flg = false;
        // console.log(String(li.cat.all));
        // if(String(li.cat.all).indexOf(all) != -1) flg = true;
        li.cat.all.forEach(function(i){
          if(String(i) == String(all)) flg = true;
        });
        // matAry.forEach(function(i){
        //   if(String(li.cat.mat).indexOf(i) != -1) flg = true;
        // });
        // widAry.forEach(function(i){
        //   if(String(li.cat.wid).indexOf(i) != -1) flg = true;
        // });
        // colAry.forEach(function(i){
        //   if(String(li.cat.col).indexOf(i) != -1) flg = true;
        // });
        // desAry.forEach(function(i){
        //   if(String(li.cat.des).indexOf(i) != -1) flg = true;
        // });
        // heeAry.forEach(function(i){
        //   if(String(li.cat.hee).indexOf(i) != -1) flg = true;
        // });

        if(flg) listSort.push(li);

      }.bind(this));

      return listSort;
    },

    getDuplicateValues : function([...array]){
      return array.filter((value, index, self) => self.indexOf(value) === index && self.lastIndexOf(value) !== index);
    }
  }
}
</script>

<style>
</style>
